import { localizeDecimal } from '@paintscout/util/builder/util/format-number/format-number'

/** A row's hours at full precision, with the language's decimal separator ("7.25" -> fr "7,25"). */
export function formatHours(value: string | number | undefined, lang?: string): string {
  const n = typeof value === 'string' ? Number.parseFloat(value) : value
  return Number.isFinite(n as number) ? localizeDecimal(String(n), lang) : ''
}

/**
 * Trim a trailing .0 so whole hours read "4", not "4.0" (matches the mock). Uses the language's
 * decimal separator ("8.5" -> fr "8,5").
 */
export function formatHourTotal(value: number, lang?: string): string {
  return localizeDecimal(value % 1 === 0 ? String(value) : value.toFixed(1), lang)
}
